/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Aspect_Ratio_HelpInputs */



/**
* | output |
* | --- |
* | "Select the aspect ratio for your media" |
*
* @param {Media_Import_Aspect_Ratio_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_aspect_ratio_help = /** @type {((inputs?: Media_Import_Aspect_Ratio_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Aspect_Ratio_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionnez le format d'image pour votre media")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie das Seitenverhältnis für Ihre Medien aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona il rapporto d'aspetto per i tuoi contenuti multimediali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите соотношение сторон для вашего медиафайла.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione la relación de aspecto para sus medios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择媒体的宽高比")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアのアスペクト比を選択してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपने मीडिया के लिए आस्पेक्ट रेशियो चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione a proporção da sua mídia.")
	return /** @type {LocalizedString} */ ("Select the aspect ratio for your media")
});